import sanitizeHtml from 'sanitize-html';
import { sanitizeConfig } from '~/lib/utils/html';
const insertCleanedValue = (el, value) => {
  el.innerHTML = sanitizeHtml(value, sanitizeConfig);
};

const cleaned = {
  created(el, binding) {
    insertCleanedValue(el, binding.value);
  },
  beforeUpdate(el, binding) {
    if (binding.value !== binding.oldValue) {
      insertCleanedValue(el, binding.value);
    }
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('cleaned', cleaned);
});
